import './components/MobileNavigation';
import './components/DesktopHeader';
import './components/HeaderLogo';
import './components/ShareAnquor';
import './components/FilterTagging';
import './components/FormRecall';
import './components/FormOfficeHours';
import './components/Advice';




document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('nav.mod_navigation button');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const thisLi = button.closest('li');
      if (!thisLi) return;

      const thisUl = button.nextElementSibling;
      if (!thisUl || thisUl.tagName.toLowerCase() !== 'ul') return;

      const parentUl = thisLi.parentElement;
      if (!parentUl || parentUl.tagName.toLowerCase() !== 'ul') return;

      // Alle offenen <ul> in dieser Ebene schließen (außer dem aktuellen)
      const siblingLis = parentUl.querySelectorAll(':scope > li');

      siblingLis.forEach(function (siblingLi) {
        const subUl = siblingLi.querySelector('ul.open');
        if (subUl && subUl !== thisUl) {
          subUl.classList.remove('open');
        }
      });

      // Toggle Klasse für dieses ul
      thisUl.classList.toggle('open');
    });
  });
});

